module.exports = __webpack_public_path__ + "img/logo_yl.e019d999.png";